
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, prop, Vue } from "vue-class-component";
import SelectPhoneCountry from "@/app/ui/views/shipment/booking/component/select-phone-country.vue";

export type ContactInfoSectionProp = {
  name: string;
  position: string;
  phone: string;
  phoneDialCode?: string;
  email: string;
};

class Props {
  modelValue = prop<ContactInfoSectionProp>({
    default: {
      name: "",
      position: "",
      phone: "",
      phoneDialCode: "",
      email: "",
    },
    required: true,
    type: Object,
  });
  error = prop<any>({
    required: true,
  });
  isMY = prop<boolean>({
    default: false,
  });
}

@Options({
  components: { SelectPhoneCountry },
  emits: ["update:modelValue", "update:error"]
})
class ClientBranchSection extends Vue.with(Props) {
  get defaultDialCode() {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.countryCode;
    return getPhoneDisplayCode(countryCode);
  }

  get displayDialCode() {
    const d = this.modelValue.phoneDialCode;
    if (d === undefined || d === null || String(d).trim() === "") {
      return this.defaultDialCode;
    }
    return d;
  }

  get errorContactBranch() {
    return {
      error: this.error.contactPhone,
      errorPhone: false,
      errorMandatory: false,
      errorPhoneCode: false,
      phoneCharMinimal: false,
      message: ""
    };
  }

  onSetPhone(v: string) {
    this.$emit("update:modelValue", { phone: v });
    this.validatePhone(v);
  }

  onSetPhoneDialCode(v: string) {
    this.$emit(
      "update:modelValue",
      Object.assign({}, this.modelValue as object, { phoneDialCode: v })
    );
  }

  mounted() {
    if (!this.modelValue.phoneDialCode) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        phoneDialCode: this.defaultDialCode
      });
    }
  }

  validateEmail(value: string) {
    this.error.contactEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  validatePhone(value: string) {
    this.error.contactPhone = !/^\d+$/.test(value) || value.length < 8;
  }

  formatNumber(value: string) {
    const newValue = value.replace(/^62|^0|^60|[\D]+/g, "");
    return newValue.startsWith("0")
      ? newValue.slice(1, newValue.length)
      : newValue;
  }

  get phoneCodePrefix() {
    return this.isMY ? "+60" : "+62";
  }
}
export default ClientBranchSection;
